var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "26px",
    height: "26px",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "rgb(193 45 132)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1143 4669 c-113 -36 -216 -135 -265 -257 l-23 -57 -3 -1750 c-2 -1236 0 -1769 8 -1815 15 -90 50 -161 111 -225 60 -64 113 -97 190 -119 50 -15 189 -16 1420 -14 l1364 3 58 23 c72 29 172 120 210 191 58 106 57 71 57 1476 l0 1290 -637 637 -638 638 -895 -1 c-859 0 -897 -1 -957 -20z m2217 -884 l585 -585 -588 0 -587 0 0 585 c0 322 1 585 3 585 1 0 265 -263 587 -585z m-80 -1442 l121 -147 -503 -503 c-277 -277 -506 -503 -510 -503 -5 0 -495 530 -556 601 l-25 31 119 119 c65 65 122 119 125 119 4 0 82 -73 174 -162 l166 -161 377 376 c207 207 380 377 384 377 4 0 61 -66 128 -147z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralTask);
export default __webpack_public_path__ + "static/media/general-task.6739b9c5be525d088433e0c57f8af2ba.svg";
export { ForwardRef as ReactComponent };